module.exports = __webpack_public_path__ + "static/media/bnr_jin577df63db9735e863f039cf2f78c18f6.webp";